// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const FormValidation = t.struct({
    complaintCorrection: t.Bool,
    failureDate: t.Bool,
    failurePart: t.Bool,
    ownershipStatus: t.Bool,
    pin: t.Bool,
    pipNumber: t.Bool,
    repairDate: t.Bool,
    responsibleAccount: t.Bool,
    useAmount: t.Bool,
    useAmountUnit: t.Bool,
    workOrderOne: t.Bool
}, 'FormValidation');

export const getDefaultState = () => new FormValidation({
    complaintCorrection: true,
    failureDate: true,
    failurePart: true,
    ownershipStatus: true,
    pin: true,
    pipNumber: true,
    repairDate: true,
    responsibleAccount: true,
    useAmount: true,
    useAmountUnit: true,
    workOrderOne: true
});

export default FormValidation;



// WEBPACK FOOTER //
// ./src/claim/pip/state/form-validation.js